import { useContext } from 'react'

import { DataManagementContext } from '../DataManager'

export default function useDataManager() {
  const context = useContext(DataManagementContext)
  if (!context) {
    throw new Error('useDataManager must be used within a DataManagementProvider')
  }
  return context
}
